<!-- 图片组件 -->
<template>
    <div>
        <div class="h100" v-if="imageData.content.style_id == 0">
            <div class="img-div wh100">
                <img
                    class="wh100 of-c"
                    v-if="imageData.content.imgList[0].picview"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px ${imageData.content.radiusData.top}px ${imageData.content.radiusData.bottom}px ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 1">
            <div class="img-div h260 w33">
                <img
                    v-if="imageData.content.imgList[0].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px 0 0 ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
            <div class="img-div h260 w66">
                <img
                    v-if="imageData.content.imgList[1].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[1].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: 0 ${imageData.content.radiusData.top}px ${imageData.content.radiusData.bottom}px 0;`
                            : `border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`
                    "
                />
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 2">
            <div class="img-div h260 w33">
                <img
                    v-if="imageData.content.imgList[0].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px 0 0 ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
            <div class="h100 w66">
                <div class="img-div wh50 h130">
                    <img
                        v-if="imageData.content.imgList[1].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[1].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: 0 ${imageData.content.radiusData.top}px 0 0;`
                                : `border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`
                        "
                    />
                </div>
                <div class="img-div wh50 h130">
                    <img
                        v-if="imageData.content.imgList[2].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[2].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: 0 0 ${imageData.content.radiusData.bottom}px 0;`
                                : `border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`
                        "
                    />
                </div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 3">
            <div class="img-div h260 w33">
                <img
                    v-if="imageData.content.imgList[0].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px 0 0 ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
            <div class="w66 h100">
                <div class="img-div wh50 h130">
                    <img
                        v-if="imageData.content.imgList[1].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[1].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: 0 ${imageData.content.radiusData.top}px 0 0;`
                                : `border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`
                        "
                    />
                </div>
                <div class="dis-flex h100">
                    <div class="img-div w50 h130">
                        <img
                            v-if="imageData.content.imgList[2].picview"
                            class="wh100 of-c br-0"
                            :src="imageData.content.imgList[2].picview"
                        />
                    </div>
                    <div class="img-div w50 h130">
                        <img
                            v-if="imageData.content.imgList[3].picview"
                            class="wh100 of-c"
                            :src="imageData.content.imgList[3].picview"
                            :style="
                                imageData.content.version
                                    ? `border-radius: 0 0 ${imageData.content.radiusData.bottom}px 0;`
                                    : `border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 4">
            <div class="img-div w50 h260">
                <img
                    v-if="imageData.content.imgList[0].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px 0 0 ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
            <div class="img-div w50 h260">
                <img
                    v-if="imageData.content.imgList[1].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[1].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: 0 ${imageData.content.radiusData.top}px ${imageData.content.radiusData.bottom}px 0;`
                            : `border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`
                    "
                />
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 5">
            <div class="img-div w33 h260">
                <img
                    v-if="imageData.content.imgList[0].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px 0 0 ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
            <div class="img-div w33 h260">
                <img
                    v-if="imageData.content.imgList[1].picview"
                    class="wh100 of-c br-0"
                    :src="imageData.content.imgList[1].picview"
                />
            </div>
            <div class="img-div w33 h260">
                <img
                    v-if="imageData.content.imgList[2].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[2].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: 0 ${imageData.content.radiusData.top}px ${imageData.content.radiusData.bottom}px 0;`
                            : `border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`
                    "
                />
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 6">
            <div class="img-div w25 h260">
                <img
                    v-if="imageData.content.imgList[0].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[0].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: ${imageData.content.radiusData.top}px 0 0 ${imageData.content.radiusData.bottom}px;`
                            : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`
                    "
                />
            </div>
            <div class="img-div w25 h260">
                <img
                    v-if="imageData.content.imgList[1].picview"
                    class="wh100 of-c br-0"
                    :src="imageData.content.imgList[1].picview"
                />
            </div>
            <div class="img-div w25 h260">
                <img
                    v-if="imageData.content.imgList[2].picview"
                    class="wh100 of-c br-0"
                    :src="imageData.content.imgList[2].picview"
                />
            </div>
            <div class="img-div w25 h260">
                <img
                    v-if="imageData.content.imgList[3].picview"
                    class="wh100 of-c"
                    :src="imageData.content.imgList[3].picview"
                    :style="
                        imageData.content.version
                            ? `border-radius: 0 ${imageData.content.radiusData.top}px ${imageData.content.radiusData.bottom}px 0;`
                            : `border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`
                    "
                />
            </div>
        </div>
        <div class="h100" v-if="imageData.content.style_id == 7">
            <div class="wh50 dis-flex">
                <div class="img-div w50 h130">
                    <img
                        v-if="imageData.content.imgList[0].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[0].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: ${imageData.content.radiusData.top}px 0 0 0;`
                                : `border-radius: ${imageData.content.marginData.topRadius}px 0 0 0;`
                        "
                    />
                </div>
                <div class="img-div w50 h130">
                    <img
                        v-if="imageData.content.imgList[1].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[1].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: 0 ${imageData.content.radiusData.top}px 0 0;`
                                : `border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`
                        "
                    />
                </div>
            </div>
            <div class="wh50 dis-flex">
                <div class="img-div w50 h130">
                    <img
                        v-if="imageData.content.imgList[2].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[2].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: 0 0 0 ${imageData.content.radiusData.bottom}px;`
                                : `border-radius: 0 0 0 ${imageData.content.marginData.bottomRadius}px;`
                        "
                    />
                </div>
                <div class="img-div w50 h130">
                    <img
                        v-if="imageData.content.imgList[3].picview"
                        class="wh100 of-c"
                        :src="imageData.content.imgList[3].picview"
                        :style="
                            imageData.content.version
                                ? `border-radius: 0 0 ${imageData.content.radiusData.bottom}px 0;`
                                : `border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imageData: {
            type: Object,
            default: {},
        },
        imgList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
    mounted() {
        if (this.imgList.length) {
            this.imageData.content.imgList = this.imgList.map((item) => ({
                picview: item,
            }));
        }
    },
    methods: {},
};
</script>

<style scoped>
img {
    pointer-events: none;
}
.img-div {
    border: 1px dashed #ccc;
}
.active {
    border: 2px dashed #ff761d;
}
.wh100 {
    width: 100%;
    height: 100%;
    display: block;
}
.wh50 {
    width: 100%;
    height: 50%;
}
.w50 {
    width: 50%;
}
.w33 {
    width: 33.333%;
}
.w66 {
    width: 66.666%;
}
.w25 {
    width: 25%;
}
.h100 {
    height: 100%;
}
.of-c {
    object-fit: cover;
    /* background-color: #fff; */
}
.dis-flex {
    display: flex;
}
.br-0 {
    border-radius: 0 0 0 0;
}
.h50 {
    height: 50%;
}
.h260 {
    height: 260px;
}
.h130 {
    height: 130px;
}
</style>